<template lang="pug">
a.button-base.line-height-none.align-center(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ButtonBase extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-base
  text-decoration none
  display block
  position relative
  outline none
  vertical-align baseline

  &:hover
    cursor pointer
</style>
